webpackJsonp([239556512387334],{

/***/ 461:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _navigation = __webpack_require__(13);
	
	var _navigation2 = _interopRequireDefault(_navigation);
	
	var _footer = __webpack_require__(12);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _seo = __webpack_require__(38);
	
	var _seo2 = _interopRequireDefault(_seo);
	
	var _seo3 = __webpack_require__(44);
	
	var _seo4 = _interopRequireDefault(_seo3);
	
	var _registerNowLeft = __webpack_require__(23);
	
	var _registerNowLeft2 = _interopRequireDefault(_registerNowLeft);
	
	var _cover = __webpack_require__(19);
	
	var _cover2 = _interopRequireDefault(_cover);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Seo = function (_React$Component) {
		(0, _inherits3.default)(Seo, _React$Component);
	
		function Seo() {
			(0, _classCallCheck3.default)(this, Seo);
			return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
		}
	
		Seo.prototype.pageClick = function pageClick(e) {
			document.getElementsByTagName('body')[0].className = '';
		};
	
		Seo.prototype.componentDidMount = function componentDidMount() {
			var mask = document.getElementById('mask');
			mask.addEventListener('touchstart', this.pageClick, false);
		};
	
		Seo.prototype.render = function render() {
			return _react2.default.createElement(
				"div",
				null,
				_react2.default.createElement(_reactHelmet2.default, {
					title: "Writing Jobs Online - UvoCorp.com",
					meta: [{ name: "description", content: "Writing jobs online. Apply for a job online with UvoCorp.com. Registration is free." }, { property: 'og:title', content: "Writing Jobs Online - UvoCorp.com" }, { property: 'og:description', content: "Writing jobs online. Apply for a job online with UvoCorp.com. Registration is free." }, { property: 'og:site_name', content: "UvoCorp.com" }, { property: 'og:type', content: "website" }, { property: 'og:image', content: _cover2.default }],
					link: [{ rel: 'canonical', href: "https://www.uvocorp.com/online_writing_jobs.html" }, { rel: 'alternate', href: "https://www.uvocorp.com/online_writing_jobs.html", hrefLang: "en" }, { rel: 'alternate', href: "https://canada.uvocorp.com/online_writing_jobs.html", hrefLang: "en-ca" }, { rel: 'alternate', href: "https://hongkong.uvocorp.com/online_writing_jobs.html", hrefLang: "en-hk" }, { rel: 'alternate', href: "https://india.uvocorp.com/online_writing_jobs.html", hrefLang: "en-in" }, { rel: 'alternate', href: "https://nigeria.uvocorp.com/online_writing_jobs.html", hrefLang: "en-ng" }, { rel: 'alternate', href: "https://pakistan.uvocorp.com/online_writing_jobs.html", hrefLang: "en-pk" }, { rel: 'alternate', href: "https://philippines.uvocorp.com/online_writing_jobs.html", hrefLang: "en-ph" }] }),
				_react2.default.createElement(
					"div",
					{ className: "header", id: "header" },
					_react2.default.createElement(_navigation2.default, null)
				),
				_react2.default.createElement(
					"div",
					{ className: "wrapper" },
					_react2.default.createElement(
						"div",
						{ className: "inner-header" },
						_react2.default.createElement(
							"div",
							{ className: "container" },
							_react2.default.createElement(
								"h1",
								null,
								"Writing Jobs Online"
							),
							_react2.default.createElement(
								_gatsbyLink2.default,
								{ to: "/register_email.html" },
								"Register now"
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "home-benefits home-block hiring-benefits" },
						_react2.default.createElement(
							"div",
							{ className: "container" },
							_react2.default.createElement(
								"h1",
								null,
								"The benefits you enjoy working as a freelance writer:"
							),
							_react2.default.createElement(
								"ul",
								{ className: "home-benefits-list" },
								_react2.default.createElement(
									"li",
									{ className: "home-benefits-1" },
									_react2.default.createElement(
										"p",
										null,
										"No registration fees"
									)
								),
								_react2.default.createElement(
									"li",
									{ className: "home-benefits-2" },
									_react2.default.createElement(
										"p",
										null,
										"High wages"
									)
								),
								_react2.default.createElement(
									"li",
									{ className: "home-benefits-3" },
									_react2.default.createElement(
										"p",
										null,
										"Working from home"
									)
								),
								_react2.default.createElement(
									"li",
									{ className: "home-benefits-4" },
									_react2.default.createElement(
										"p",
										null,
										"Orders in the sphere ",
										_react2.default.createElement("br", null),
										"of your interest"
									)
								),
								_react2.default.createElement(
									"li",
									{ className: "home-benefits-5" },
									_react2.default.createElement(
										"p",
										null,
										"24/7 available ",
										_react2.default.createElement("br", null),
										"support team"
									)
								),
								_react2.default.createElement(
									"li",
									{ className: "home-benefits-6" },
									_react2.default.createElement(
										"p",
										null,
										"Payments always ",
										_react2.default.createElement("br", null),
										"on time"
									)
								),
								_react2.default.createElement(
									"li",
									{ className: "home-benefits-7" },
									_react2.default.createElement(
										"p",
										null,
										"Manage your time ",
										_react2.default.createElement("br", null),
										"and workload yourself"
									)
								)
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "home-pricing-info" },
						_react2.default.createElement(
							"div",
							{ className: "container" },
							_react2.default.createElement(
								"p",
								null,
								"There is no other company that offers ",
								_react2.default.createElement(
									"strong",
									null,
									"$15"
								),
								"/page written by an ",
								_react2.default.createElement(
									"span",
									{ className: "home-pricing-info-role" },
									"ESL"
								),
								" writer and ",
								_react2.default.createElement(
									"strong",
									null,
									"$26"
								),
								"/page completed by an ",
								_react2.default.createElement(
									"span",
									{ className: "home-pricing-info-role" },
									"ENL"
								),
								" writer."
							),
							_react2.default.createElement(
								_gatsbyLink2.default,
								{ to: "/prices.html" },
								"View Pricing ",
								_react2.default.createElement(
									"svg",
									{ id: "arrow-right", width: "22", height: "22" },
									_react2.default.createElement("path", { fill: "#black", d: "M17.2,10.2l-3.2,3c-0.1,0.1-0.2,0.1-0.3,0c-0.1,0-0.2-0.1-0.2-0.2v-1.9H3c-0.2,0-0.3-0.1-0.3-0.3V9.2 C2.8,9,2.9,8.9,3,8.9h10.5V7.1c0-0.1,0.1-0.2,0.2-0.2c0.1,0,0.2,0,0.3,0l3.2,2.9c0.1,0.1,0.1,0.1,0.1,0.2 C17.2,10.1,17.2,10.1,17.2,10.2z" })
								)
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "inner-white hiring seo" },
						_react2.default.createElement(
							"div",
							{ className: "container" },
							_react2.default.createElement(
								"h2",
								null,
								"Writers wanted"
							),
							_react2.default.createElement(
								"div",
								{ className: "row" },
								_react2.default.createElement(
									"div",
									{ className: "col-md-9" },
									_react2.default.createElement(
										"p",
										null,
										"Dear potential ",
										_react2.default.createElement(
											_gatsbyLink2.default,
											{ to: "/" },
											"UVOCORP"
										),
										" writers, we are currently hiring:"
									),
									_react2.default.createElement(
										"ol",
										{ className: "hiring-steps" },
										_react2.default.createElement(
											"li",
											null,
											"Writers who are Native Speakers of English (these writers have exclusive access to orders which need to be written by a Native Speaker of English);"
										),
										_react2.default.createElement(
											"li",
											null,
											"English as a Second Language writers with a profound knowledge in Humanities, Business Studies, Applied, and Social Sciences;"
										),
										_react2.default.createElement(
											"li",
											null,
											"Writers with a profound knowledge in the following disciplines. Working only on them on a permanent basis is our internal separate project:"
										)
									),
									_react2.default.createElement(
										"ul",
										{ className: "hiring-disciplines" },
										_react2.default.createElement(
											"li",
											{ className: "discipline_8" },
											"Accounting"
										),
										_react2.default.createElement(
											"li",
											{ className: "discipline_15" },
											"Architecture, Building and Planning"
										),
										_react2.default.createElement(
											"li",
											{ className: "discipline_14" },
											"Biology (and other Life Sciences)"
										),
										_react2.default.createElement(
											"li",
											{ className: "discipline_13" },
											"Chemistry"
										),
										_react2.default.createElement(
											"li",
											{ className: "discipline_1" },
											"Engneering"
										),
										_react2.default.createElement(
											"li",
											{ className: "discipline_10" },
											"Civil Engineering"
										),
										_react2.default.createElement(
											"li",
											{ className: "discipline_7" },
											"Computer Science"
										),
										_react2.default.createElement(
											"li",
											{ className: "discipline_5" },
											"IT, Web"
										),
										_react2.default.createElement(
											"li",
											{ className: "discipline_3" },
											"Finance"
										),
										_react2.default.createElement(
											"li",
											{ className: "discipline_11" },
											"Mathematics"
										),
										_react2.default.createElement(
											"li",
											{ className: "discipline_12" },
											"Physics"
										),
										_react2.default.createElement(
											"li",
											{ className: "discipline_4" },
											"Statistics"
										)
									)
								),
								_react2.default.createElement(
									"div",
									{ className: "hiring-img" },
									_react2.default.createElement("img", { src: _seo4.default, alt: "Seo Image" })
								)
							),
							_react2.default.createElement(
								"div",
								{ className: "row seo-row" },
								_react2.default.createElement(
									"div",
									{ className: "col-md-4 seo-img-container" },
									_react2.default.createElement(
										"div",
										{ className: "seo-img" },
										_react2.default.createElement("img", { src: _seo2.default, alt: "Seo Image" })
									)
								),
								_react2.default.createElement(
									"div",
									{ className: "col-md-8" },
									_react2.default.createElement(
										"h2",
										{ className: "left" },
										"Writing jobs online are all over the internet"
									),
									_react2.default.createElement(
										"p",
										null,
										"Writing jobs online can be found all over the Internet, offering you numerous writing positions, but rarely paying rates you need to make a living for your family. The internet provides a great number of opportunities for writers in today's markets. Stories on the news praise the ability of writers to make money from online sources;, however, writing jobs online do not pay quite enough, especially with many of the companies that are available in a quick search. You need a freelance writing job that provides you with security, pays what you are worth, and provides you with opportunities to grow as a writer. Here at ",
										_react2.default.createElement(
											_gatsbyLink2.default,
											{ to: "/" },
											"UVOCorp"
										),
										", we provide you with all of this and more. Our writing jobs online are designed to provide educated writers with a writing position that fits their needs and strengths. Those who hold a BA or a BSc, a Master's, or PhD can work within fields of their particular interest, and earn income to match."
									),
									_react2.default.createElement(
										"p",
										null,
										"If you are a writer with experience in writing projects, and are seeking to make more than a few cents each word, you need to visit our pages and find out how we can help you make a living doing what you love best \u2013 writing. Our company is dedicated to developing industry leadership, which is why our ",
										_react2.default.createElement(
											_gatsbyLink2.default,
											{ to: "/writing_jobs_from_home.html" },
											"writing jobs"
										),
										" online pay better than most others do. We want quality, and are willing to pay for it. Unlike other writing companies, we do not force you to write within a single discipline, or at a set rate. Instead, we offer opportunities to work directly with customers, write in disciplines that you feel comfortable in, and the ability to set your earnings each month, by selecting the work to complete. Our writing jobs online are developed with two primary concerns \u2013 matching the needs of customers to writers, and developing a home for professional writers to accomplish their personal goals."
									),
									_react2.default.createElement(
										"p",
										null,
										"Many organizations pay a few cents per word, because they do not realize how much work is involved in writing quality material, whether it is for short articles or longer reports. Here, our administrative staff and owners have all done the same work we ask our writers to do, and have many of the same qualifications. Online writing jobs advertized by inexperienced management often do not involve researching the subjects, or providing accurate templates or formatting. They simply assume you want to work for less than a dollar an hour. Here, we understand, and pay you what you are worth. We offer competitive rates that allow you to make as much as $50 an hour. Additionally, our writing jobs online focus on your interests, and appoint assignments that best fit your disciplines, skills, and interests. You can work as much or as little as you like, for the hours you prefer, and take this work on as a second job if you would like to."
									),
									_react2.default.createElement(
										"h2",
										{ className: "inner-left-intext" },
										"Finally, writing jobs online"
									),
									_react2.default.createElement(
										"p",
										null,
										"It makes sense to apply the new growth of communication to the world around us. To do this, writing jobs online must focus on seeking out new talent and building a large talent base of successful employees who fit this organization\u2019s goals and standards. Our company is dedicated to doing just this,by finding successful, professional writers, such as yourself, to join our workforce and assist us in building the best writing teams online. Our goals are the goals of our founders - to establish a place where writers can succeed at what they do best, which is writing. When you want the best writing job online to pay you what you are worth, apply here at ",
										_react2.default.createElement(
											_gatsbyLink2.default,
											{ to: "/" },
											"UVOCorp"
										),
										", and get a job that fits your particular needs so that you can excel at what you enjoy."
									)
								)
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "inner-registration inner-registration-left" },
						_react2.default.createElement(
							"div",
							{ className: "container" },
							_react2.default.createElement(
								"div",
								{ className: "inner-registration-image" },
								_react2.default.createElement(
									"div",
									{ className: "img inner-registration-img" },
									_react2.default.createElement("img", { src: _registerNowLeft2.default, alt: "Start registration" })
								)
							),
							_react2.default.createElement(
								"div",
								{ className: "inner-registration-text" },
								_react2.default.createElement(
									"div",
									{ className: "inner-registration-title" },
									"Register now ",
									_react2.default.createElement("br", null),
									"to start earning!"
								),
								_react2.default.createElement(
									"div",
									{ className: "inner-registration-button" },
									_react2.default.createElement(
										_gatsbyLink2.default,
										{ to: "/register_email.html" },
										"Start registration"
									)
								)
							)
						)
					),
					_react2.default.createElement(_footer2.default, null)
				),
				_react2.default.createElement("div", { id: "mask", className: "c-mask" })
			);
		};
	
		return Seo;
	}(_react2.default.Component);
	
	exports.default = Seo;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-online-writing-jobs-html-js-d444c80b5aeb1e164e13.js